import { useState } from "react";
import { ErrorPanel, LinkButton, Skeleton } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useGetVehiclesQuery } from "@/redux/apis/vehicle/vehicleApi";
import { Vehicle } from "@/redux/slices/vehicle/types";
import { MyVehiclesTable } from "./MyVehiclesTable";
import { useGetMyVehiclesParams } from "./hooks/useGetMyVehiclesParams";
import { ArchiveVehicleModal } from "./modals/ArchiveVehicleModal";

export const MyVehiclesPanel = () => {
  const { params, search, filters } = useGetMyVehiclesParams();
  const {
    isFetching,
    data: response,
    error,
  } = useGetVehiclesQuery(params, {
    refetchOnMountOrArgChange: true,
  });
  const [pendingArchive, setPendingArchive] = useState<Vehicle | undefined>();

  const isFiltersEmpty = Object.values(filters).every((el) => el === undefined);
  const hasSearchOrFilters = search || !isFiltersEmpty;

  if (error) return <ErrorPanel messages={getErrorMessages(error)} />;
  if (isFetching) return <Skeleton />;

  if (response && response.vehicles.length > 0)
    return (
      <>
        <MyVehiclesTable items={response.vehicles ?? []} setPendingArchive={setPendingArchive} />
        <MyVehiclesTable.Pagination page={response.page} />
        <ArchiveVehicleModal pendingArchive={pendingArchive} setPendingArchive={setPendingArchive} />
      </>
    );

  const getEmptyDescription = () => {
    if (hasSearchOrFilters) {
      return "There are no vehicles matching your filter criteria at the moment.";
    }
    return "You haven't added anything to this section. Get started by clicking the button below.";
  };

  return (
    <EmptyState title="Vehicle Manager" description={getEmptyDescription()}>
      {!hasSearchOrFilters && (
        <div className="flex flex-row gap-4">
          <LinkButton to="../my-vehicles/add" variant="primary" startIcon="Add" size="md">
            Add Vehicle
          </LinkButton>
        </div>
      )}
    </EmptyState>
  );
};
